import { render, staticRenderFns } from "./my-gooru.vue?vue&type=template&id=39a13417&scoped=true&"
import script from "./my-gooru.ts?vue&type=script&lang=ts&"
export * from "./my-gooru.ts?vue&type=script&lang=ts&"
import style0 from "./my-gooru.scss?vue&type=style&index=0&id=39a13417&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a13417",
  null
  
)

export default component.exports